const resources = {
  TOPIC: { url: "content-admin/topic", label: "Topic", title: "Topics" },
  CONTENT: {
    url: "content-admin/content",
    label: "Content",
    title: "Contents",
    es_label: "Content (Spanish)",
  },
  CONTENT_TAGS: {
    url: "content-admin/content-tag",
    label: "Content Tag",
    title: "Content Tags",
  },
  CONTENT_ITEMS: {
    url: "content-admin/content-item",
    label: "Content Item",
    title: "Content Items",
  },
  CONTENT_ITEMS_ORDERABLE: {
    url: "content-admin/content-item-orderable",
    label: "",
    title: "",
  },
  CONTENTS_ORDERABLE: {
    url: "content-admin/content-orderable",
    label: "",
    title: "",
  },
  CONTENTS_PUBLICATION: {
    url: "content-admin/content-publication",
    label: "",
    title: "",
  },
  CONTENTS_DUPLICATION: {
    url: "content-admin/content-duplication",
    label: "",
    title: "",
  },
  TOPICS_ORDERABLE: {
    url: "content-admin/topic-orderable",
    label: "",
    title: "",
  },
  LOGOUT: {
    url: "session/logout",
    label: "",
    title: "",
  },
};

export default resources;
